import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { Translation, TranslocoLoader } from '@jsverse/transloco';

@Service()
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  /**
   * Loads the translation file for the requested language via HTTP.
   * @param lang - The language code to load (e.g. `'en'`, `'ar'`).
   * @returns An observable that emits the translation key-value map.
   */
  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
